module.exports = __webpack_public_path__ + "static/img/adaptivity.9f2eaa9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gameDetails/FenyxRising/top/adaptivity.jpg
// module id = wMaK
// module chunks = 0